module.exports = __webpack_public_path__ + "static/img/widget-5.b5a40db8.png";